import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "filter",
  "use": "filter-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" class=\"feather feather-filter\" viewBox=\"0 0 24 24\" id=\"filter\"><path d=\"M22 3H2l8 9.46V19l4 2v-8.54L22 3z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol